export { Tabs } from './Tabs';
export { TabsContent } from './TabsContent';
export { TabsItem } from './TabsItem';
export { TabsList } from './TabsList';
